/**
 * custom-theme.js
 * Theme-owner global scripts for Lucid Youth / Noon All Day.
 * Extracted from inline <script> in layout/theme.liquid.
 */

// Prevent bare hash links from scrolling to the top of the page.
document.querySelectorAll('a[href="#"]').forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.preventDefault();
  });
});
